// 施工実施トップ。工事プルダウンと「施工箇所(未施工)」「施工実施(履歴)」の 2 タブを切替表示。

import { useState } from "react";
import { Box, Button, Chip, Stack, Typography, Tabs, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { useLocation, useNavigate } from "react-router-dom";
import { PageContext } from "../PageContext";
import { WorkSelectField } from "../../../components/input/WorkSelectField";
import { useFullDb } from "../../../api/dbSlice";
import { ContentLoading } from "../../../components/Loading";
import { useMountSync } from "../../../util/useMountSync";
import { useSelectedWork } from "../../../util/useSelectedWork";
import ConstructionRecordTable from "./ConstructionRecordTable";
import ExecuteListPage from "./ExecuteListPage";

export default function ConstructionListPage({ pageContext }: { pageContext: PageContext }) {
  const { db, loading, reload } = useFullDb(pageContext.api.indexedDB, pageContext.api.currentUser.id);
  const navigate = useNavigate();
  const location = useLocation();
  const [workFilter, setWorkFilter] = useSelectedWork();
  // セッション保存後は「施工実施」タブへ戻す(mock backToTab)。
  const [tab, setTab] = useState<number>(() => {
    const state: unknown = location.state;
    if (typeof state === "object" && state !== null && "backToTab" in state && state.backToTab === "construction") {
      return 1;
    }
    return 0;
  });

  // IDBは差分アップロード専用同期のため、施工系はサーバ値が落ちてこない。表示前に全件DLして取り込む。
  // 同期完了までローディング表示にする(同期前のローカル内容が一瞬表示されるのを防ぐ)。
  const syncing = useMountSync(pageContext.api.isOnline, () => pageContext.api.entities.syncConstructionData(), reload);

  const activeWorks = db.works.filter((w) => w.deleted_at == null);
  const ready = !loading && !syncing;

  return (
    <Stack p={3} gap={2} maxWidth={1400} mx="auto">
      <Stack direction="row" alignItems="center" gap={1}>
        <EngineeringIcon color="action" />
        <Typography variant="h4" fontWeight="bold">施工実施</Typography>
        <Chip size="small" color="info" label="現場作業員向け" sx={{ pointerEvents: "none" }} />
        <Box flex={1} />
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate("new/")}>
          新規施工実施
        </Button>
      </Stack>

      {!ready && <ContentLoading />}
      {ready && (
        <>
          <Stack direction="row" gap={2} alignItems="center" flexWrap="wrap">
            <WorkSelectField options={activeWorks.map((w) => ({ id: w.id, label: w.short_name ?? w.official_name }))} value={workFilter} onChange={setWorkFilter} allLabel="すべて" sx={{ minWidth: 280 }} />
          </Stack>

          <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tab label="施工箇所" />
            <Tab label="施工実施" />
          </Tabs>

          {tab === 0 && <ExecuteListPage db={db} workFilter={workFilter} />}
          {tab === 1 && <ConstructionRecordTable db={db} workFilter={workFilter} />}
        </>
      )}
    </Stack>
  );
}
